import { LoginCard } from '@/components/layout/LoginCard';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '@/components/ui/InputOTP';
import { Button, FormLabel, StandaloneLink } from '@/components/wm';
import { apiRequest } from '@/utils/request';
import { REGEXP_ONLY_DIGITS_AND_CHARS } from 'input-otp';
import React, { useEffect, useState } from 'react';

export function LoginOTP({ email, password, onAlert, backToLogin }) {
    const
        [autoTrigger, setAutoTrigger] = useState(true),
        [code, setCode] = useState(''),
        [formFilled, setFormFilled] = useState(false),
        [loadingSubmit, setLoadingSubmit] = useState(false),
        [loadingResend, setLoadingResend] = useState(false);

    useEffect(() => {
        const formFilled = code.length === 6;

        setFormFilled(formFilled);
    }, [code]);

    const onOtpChange = value => {
        setCode(value);

        if (autoTrigger && value.length === 6) {
            handleOtpSubmit(value);
            setAutoTrigger(false);
        }
    };

    const handleOtpSubmit = async value => {
        setLoadingSubmit(true);

        const otpCode = value || code;

        if (otpCode.length !== 6) {
            onAlert(i18next.t('otp.enter_6_digit_code'), 'warning', i18next.t('ui.attention'));
            return;
        }

        const data = {
            email,
            password,
            code: otpCode
        };

        try {
            const response = await apiRequest('/login', 'POST', data);

            if (response.status === 201) {
                WiseMetering.startApp();
            } else {
                onAlert(i18next.t('ui.login.failed'), 'destructive', i18next.t('alert_boxes.failed'));
            }
        } catch (err) {
            const errorMessage = err.response?.data?.error?.capitalize() || i18next.t('alert_boxes.error_occurred');

            onAlert(errorMessage, 'destructive', i18next.t('alert_boxes.failed'));
        } finally {
            setTimeout(() => {
                setLoadingSubmit(false);
            }, 500);
        }
    };

    const handleResendOtp = async () => {
        setLoadingResend(true);

        const data = {
            email,
            password
        };

        try {
            const response = await apiRequest('/login', 'POST', data);

            if (response.status === 200) {
                onAlert(i18next.t('otp.new_code_sent'), 'info', i18next.t('alert_boxes.info'));
            }
        } catch (err) {
            const errorMessage = err.response?.data?.error?.capitalize() || i18next.t('alert_boxes.error_occurred');

            onAlert(errorMessage, 'destructive', i18next.t('alert_boxes.failed'));
        } finally {
            setTimeout(() => {
                setLoadingResend(false);
            }, 500);
        }
    };

    return (
        <LoginCard>
            <div className="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-mb-4">
                <FormLabel htmlFor="otp">{i18next.t('otp.enter_code_sent_to_email')}</FormLabel>
                <InputOTP maxLength={6} onChange={onOtpChange} pattern={REGEXP_ONLY_DIGITS_AND_CHARS}>
                    <InputOTPGroup className="tw-flex tw-gap-4">
                        <InputOTPSlot className="tw-border-gray-300 tw-rounded-md !tw-border-solid !tw-border-2" index={0}/>
                        <InputOTPSlot className="tw-border-gray-300 tw-rounded-md !tw-border-solid !tw-border-2" index={1}/>
                        <InputOTPSlot className="tw-border-gray-300 tw-rounded-md !tw-border-solid !tw-border-2" index={2}/>
                        <InputOTPSlot className="tw-border-gray-300 tw-rounded-md !tw-border-solid !tw-border-2" index={3}/>
                        <InputOTPSlot className="tw-border-gray-300 tw-rounded-md !tw-border-solid !tw-border-2" index={4}/>
                        <InputOTPSlot className="tw-border-gray-300 tw-rounded-md !tw-border-solid !tw-border-2" index={5}/>
                    </InputOTPGroup>
                </InputOTP>
            </div>
            <Button className="tw-w-full" disabled={!formFilled} loading={loadingSubmit} onClick={() => handleOtpSubmit()} type="submit" variant="secondary">
                {i18next.t('otp.verify')}
            </Button>
            <div className="tw-flex tw-justify-between tw-gap-2">
                <StandaloneLink icon="arrowLeftCircle" onAction={backToLogin} text={i18next.t('ui.passwords.back_to_login')}/>
                <StandaloneLink loading={loadingResend} onAction={handleResendOtp} text={i18next.t('otp.resend_code')}/>
            </div>
        </LoginCard>
    );
}
